<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("Ticket Type", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("ticket type", 2) }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <router-link variant="default" class="btn-blue" to="add-ticket-type">{{
          $tc("add")
        }}</router-link>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <!-- <b-dropdown
            :text="filter_is_active_label"
            variant="dropdown-curve"
            class="ml-auto mr-3 movie-dropdown"
          >
            <b-dropdown-item @click="onChangeFilterIsActive('Active')"
            >Active</b-dropdown-item
            >
            <b-dropdown-item @click="onChangeFilterIsActive('Inactive')"
            >Inactive</b-dropdown-item
            >
            <b-dropdown-item @click="onChangeFilterIsActive('All')">All</b-dropdown-item>
          </b-dropdown> -->
          <FilterByStatusDropdown
            :onSelect="
              filterIsActive => {
                getTicketTypesList(filterIsActive);
              }
            "
          />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'tt_name'"
              @click="onSortValue('tt_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('tt_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('tt_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("Ticket Types") }}
          </th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="TicketTypes.length > 0">
        <tr v-for="(item, key) in TicketTypes" :key="key">
          <td>{{ $tc(item.tt_name, 1) }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.tt_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot :status="item.tt_is_active ? 'active' : 'inactive'" />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-ticket-type', item)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="TicketTypes.length == 0">
        <td colspan="2">
          <!-- {{ errors.message }} -->
          <NoRecords/>
          </td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import MasterService from "@/services/MasterService";
import TicketTypes from "@/helper/formJSONMaster/TicketTypes";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";


export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: TicketTypes.Methods,
      TicketTypes: [],
      customErrors: {
        message: ""
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: ""
      // filter_is_active_label: 'Active',
      // filter_is_active: "Y"
    };
  },
  beforeMount() {
    this.getTicketTypesList();
    this.getviewingnumber();
  },
  methods: {
    // onChangeFilterIsActive(option) {
    //   this.filter_is_active_label = option;
    //   switch (option.toLowerCase()) {
    //     case 'active':
    //       this.filter_is_active = 'Y';
    //       break;
    //     case 'inactive':
    //       this.filter_is_active = 'N';
    //       break;
    //     default:
    //       this.filter_is_active = null;
    //       break;
    //   }
    //   this.getTicketTypesList();
    // },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getTicketTypesList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getTicketTypesList();
      } else {
        this.currentPage = event;
        this.getTicketTypesList();
      }
    },
    /* eslint-disable */
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { tt_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: tt_id
        }
      });
    },

    getTicketTypesList: function(filterIsActive = 'Y') {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        filter_is_active: filterIsActive
      };
      this.TicketTypes = [];
      MasterService.ViewTicketTicketType(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.TicketTypes = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TicketType/listTicketType.vue